export default "__VITE_ASSET__BSC$Teqq__"